import type { TChatDto } from '@homepal/api-contract'

import { Message } from './types'

// Local ids come from the caller's counter, so they never collide with the
// ids of replies streamed afterwards.
export function toMessages(
  chat: TChatDto,
  nextId: () => number
): { messages: Message[]; suggestions: string[] } {
  const messages: Message[] = chat.messages.map((message) => ({
    id: nextId(),
    messageId: message.id,
    rating: message.rating,
    role: message.role,
    content: message.content,
    reasoningText: message.reasoning_text ?? undefined,
    thinkingSteps: message.thinking_steps ?? undefined,
    durationMs: message.duration_ms,
    pending: false,
    hydrated: true
  }))

  const lastAssistant = [...chat.messages]
    .reverse()
    .find((message) => message.role === 'assistant')

  return { messages, suggestions: lastAssistant?.suggestions ?? [] }
}
